import { api } from "~/api";
import { t } from "i18next";

const defaultSpeakerIds = {
  voicevox: 1,
  aivisSpeech: 1878365376, // コハク-normal
};

/**
 * VOICEVOXのウォームアップ処理
 * 初回起動時に事前にAPIへリクエストを送信することで、
 * 最初のユーザー会話時の応答速度を向上させる
 *
 * @throws {Error} ウォームアップリクエストが失敗した場合
 */
export const warmupVoicevox = async (): Promise<void> => {
  const warmupKey = "voicevoxWarmupCompleted";

  // sessionStorageに完了フラグがある場合はスキップ
  if (sessionStorage.getItem(warmupKey) === "true") return;

  try {
    // audioQuery APIを実行
    const queryResult = await api.voicevox.audioQuery.mutate({
      speaker: defaultSpeakerIds.voicevox,
      text: t("loading"),
    });

    if (!queryResult) {
      throw new Error("VOICEVOX audioQuery returned null");
    }

    // synthesis APIを実行
    const synthesisResult = await api.voicevox.synthesis.mutate({
      speaker: defaultSpeakerIds.voicevox,
      queryJson: queryResult,
    });

    if (!synthesisResult) {
      throw new Error("VOICEVOX synthesis returned null");
    }

    // どちらも疎通が確認できたらウォームアップ完了
    sessionStorage.setItem(warmupKey, "true");
    console.info("VOICEVOX Warming Completed.");
  } catch (error) {
    throw new Error(
      error instanceof Error
        ? `VOICEVOXウォームアップに失敗しました: ${error.message}`
        : "VOICEVOXウォームアップに失敗しました"
    );
  }
};

/**
 * AivisSpeechのウォームアップ処理
 * 初回起動時に事前にAPIへリクエストを送信することで、
 * 最初のユーザー会話時の応答速度を向上させる
 *
 * @throws {Error} ウォームアップリクエストが失敗した場合
 */
export const warmupAivisSpeech = async (): Promise<void> => {
  const warmupKey = "aivisspeechWarmupCompleted";

  // sessionStorageに完了フラグがある場合はスキップ
  if (sessionStorage.getItem(warmupKey) === "true") return;

  try {
    // audioQuery APIを実行
    const queryResult = await api.aivisspeech.audioQuery.mutate({
      speaker: defaultSpeakerIds.aivisSpeech,
      text: t("loading"),
    });

    if (!queryResult) {
      throw new Error("AivisSpeech audioQuery returned null");
    }

    // synthesis APIを実行
    const synthesisResult = await api.aivisspeech.synthesis.mutate({
      speaker: defaultSpeakerIds.aivisSpeech,
      queryJson: queryResult,
    });

    if (!synthesisResult) {
      throw new Error("AivisSpeech synthesis returned null");
    }

    // どちらも疎通が確認できたらウォームアップ完了
    sessionStorage.setItem(warmupKey, "true");
    console.info("AivisSpeech Warming Completed.");
  } catch (error) {
    throw new Error(
      error instanceof Error
        ? `AivisSpeechウォームアップに失敗しました: ${error.message}`
        : "AivisSpeechウォームアップに失敗しました"
    );
  }
};
